var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"8f931dd15078e94a696fa549fdd72a0cc884cab2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prod-webapp@rare-sense-inc"]={id:"8f931dd15078e94a696fa549fdd72a0cc884cab2"};
      